var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasherArmBottomLowPressureCold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 159 39",
    style: {
      enableBackground: "new 0 0 159 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00B7FF;}\r\n\t.st1{fill:#00ADEE;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#FF001C;}\r\n\t.st4{fill:#929497;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.4,17.29c0.7-0.15,1.15-0.84,1-1.54c-0.14-0.61-0.67-1.02-1.27-1.02c-0.09,0-0.18,0.01-0.28,0.03 c-0.7,0.15-1.14,0.84-0.99,1.54C46.01,17,46.7,17.44,47.4,17.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.64,15.47c0.7-0.1,1.2-0.75,1.1-1.47c-0.09-0.64-0.64-1.11-1.28-1.11c-0.06,0-0.12,0-0.18,0.01 c-0.71,0.1-1.21,0.75-1.11,1.46C56.27,15.07,56.93,15.57,57.64,15.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.99,14.41c0.71-0.05,1.26-0.67,1.21-1.38c-0.05-0.69-0.62-1.21-1.3-1.21c-0.03,0-0.06,0-0.09,0 c-0.71,0.05-1.25,0.67-1.2,1.38C66.66,13.92,67.27,14.46,67.99,14.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.4,14.06c0.71,0,1.29-0.58,1.29-1.29c0-0.72-0.58-1.3-1.29-1.3c-0.72,0-1.3,0.58-1.3,1.3 C77.1,13.48,77.68,14.06,78.4,14.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.8,14.4c0.72,0.05,1.33-0.49,1.38-1.2c0.05-0.72-0.49-1.34-1.2-1.38c-0.03-0.01-0.06-0.01-0.09-0.01 c-0.68,0-1.25,0.53-1.3,1.21C87.55,13.74,88.09,14.36,88.8,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.36,19.93c0.69-0.21,1.07-0.94,0.86-1.62c-0.18-0.56-0.69-0.91-1.24-0.91c-0.13,0-0.26,0.02-0.39,0.06 c-0.68,0.21-1.07,0.94-0.85,1.62C35.95,19.77,36.68,20.15,37.36,19.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.37,32.57c-0.25-0.27-0.6-0.41-0.94-0.41c-0.32,0-0.64,0.11-0.89,0.35c-0.37,0.34-0.47,0.85-0.35,1.3 h2.47C10.78,33.38,10.7,32.91,10.37,32.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.27,32.45c-0.25-0.24-0.57-0.35-0.88-0.35c-0.35,0-0.7,0.14-0.95,0.41c-0.34,0.36-0.41,0.86-0.26,1.3 h2.44C148.77,33.34,148.66,32.8,148.27,32.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.65,23.53c0.65-0.28,0.96-1.05,0.67-1.7c-0.21-0.49-0.69-0.78-1.19-0.78c-0.17,0-0.35,0.03-0.52,0.1 c-0.65,0.29-0.95,1.05-0.67,1.71C26.23,23.52,26.99,23.82,27.65,23.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.48,28.26c0.61-0.38,0.8-1.18,0.43-1.79c-0.25-0.39-0.67-0.61-1.11-0.61c-0.23,0-0.46,0.06-0.67,0.19 c-0.62,0.37-0.8,1.17-0.43,1.78C17.07,28.44,17.87,28.64,18.48,28.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.15,23.5c0.66,0.28,1.42-0.02,1.71-0.68c0.28-0.65-0.02-1.42-0.68-1.7c-0.16-0.08-0.34-0.11-0.51-0.11 c-0.5,0-0.98,0.29-1.19,0.78C128.19,22.45,128.5,23.21,129.15,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.43,19.91c0.69,0.21,1.42-0.17,1.63-0.85c0.21-0.69-0.17-1.42-0.86-1.63c0.01,0,0.01,0,0.01,0 c-0.13-0.04-0.26-0.06-0.39-0.06c-0.55,0-1.06,0.36-1.24,0.91C118.37,18.97,118.75,19.69,119.43,19.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.32,28.21c0.61,0.38,1.41,0.18,1.78-0.43c0.37-0.61,0.18-1.41-0.43-1.78c-0.21-0.13-0.45-0.19-0.68-0.19 c-0.43,0-0.86,0.22-1.1,0.62C137.51,27.04,137.71,27.84,138.32,28.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.16,15.46c0.71,0.09,1.36-0.4,1.46-1.11s-0.4-1.37-1.11-1.46c-0.06-0.01-0.12-0.02-0.18-0.02 c-0.63,0-1.19,0.47-1.28,1.12C97.94,14.7,98.44,15.36,99.16,15.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.39,17.27c0.7,0.16,1.39-0.29,1.54-0.99c0.16-0.7-0.29-1.39-0.99-1.54c-0.09-0.02-0.18-0.03-0.28-0.03 c-0.59,0-1.13,0.41-1.26,1.02C108.25,16.42,108.69,17.12,109.39,17.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.76,24.12c1.08-0.04,1.91-0.94,1.87-2.02c-0.03-1.05-0.9-1.88-1.94-1.88c-0.02,0-0.05,0-0.07,0 c-1.07,0.04-1.91,0.95-1.87,2.03C71.79,23.32,72.69,24.16,73.76,24.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.74,33.1c0.96-0.48,1.34-1.65,0.86-2.62c-0.35-0.68-1.03-1.07-1.74-1.07c-0.3,0-0.6,0.07-0.88,0.21 c-0.96,0.49-1.34,1.66-0.86,2.63C32.61,33.2,33.78,33.59,34.74,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.99,25L93.99,25c1.07,0.14,2.05-0.62,2.18-1.69c0.13-1.06-0.62-2.05-1.69-2.18 c-0.08-0.01-0.16-0.01-0.24-0.01c-0.97,0-1.81,0.72-1.93,1.7C92.17,23.88,92.93,24.87,93.99,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.99,33.12c0.97,0.47,2.14,0.07,2.61-0.89c0.47-0.97,0.06-2.14-0.9-2.62c0,0.01,0,0.01,0,0.01 c-0.28-0.14-0.57-0.2-0.85-0.2c-0.72,0-1.41,0.4-1.75,1.09C121.62,31.48,122.03,32.65,122.99,33.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.69,29.37c1.02,0.33,2.12-0.22,2.46-1.24c0.34-1.02-0.21-2.13-1.23-2.47c-0.21-0.06-0.41-0.1-0.62-0.1 c-0.81,0-1.57,0.52-1.84,1.34C112.12,27.92,112.67,29.03,113.69,29.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.66,24.92c1.07-0.12,1.83-1.09,1.7-2.17c-0.12-0.99-0.96-1.71-1.93-1.71c-0.08,0-0.16,0-0.23,0.01 c-1.07,0.13-1.83,1.1-1.7,2.18C61.63,24.28,62.6,25.05,63.66,24.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.7,26.6c1.05-0.23,1.72-1.27,1.49-2.33c-0.2-0.91-1-1.53-1.9-1.53c-0.14,0-0.27,0.02-0.41,0.05 c-0.01,0-0.01,0-0.01,0c-1.04,0.23-1.71,1.26-1.48,2.32C51.61,26.16,52.65,26.83,53.7,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.98,29.27c1.02-0.35,1.57-1.45,1.23-2.48c-0.28-0.81-1.03-1.32-1.85-1.32c-0.2,0-0.41,0.03-0.62,0.1 c-1.02,0.34-1.56,1.45-1.22,2.47C41.86,29.06,42.97,29.61,43.98,29.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.96,26.71c1.05,0.22,2.09-0.44,2.31-1.49c0.24-1.05-0.43-2.09-1.48-2.33c0,0.01,0,0.01,0,0.01 c-0.14-0.03-0.28-0.05-0.42-0.05c-0.89,0-1.7,0.62-1.89,1.53C102.25,25.44,102.91,26.48,103.96,26.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.9,24.15c1.07,0.04,1.98-0.79,2.03-1.86c0.04-1.07-0.79-1.99-1.86-2.04c-0.03,0-0.06,0-0.09,0 c-1.04,0-1.9,0.82-1.94,1.86C81.99,23.2,82.83,24.1,83.9,24.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.46,32.05c0.04-1.25-0.95-2.31-2.2-2.34c-0.02,0-0.05,0-0.07,0c-1.22,0-2.23,0.97-2.26,2.21 c-0.02,0.77,0.34,1.45,0.91,1.88h2.71C86.08,33.41,86.45,32.78,86.46,32.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.72,32.97c0.14-1.24-0.76-2.38-2-2.52c-0.09-0.01-0.18-0.01-0.26-0.01c-1.14,0-2.12,0.85-2.25,2.02 c-0.05,0.49,0.05,0.95,0.27,1.35h3.98C96.59,33.55,96.69,33.27,96.72,32.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.09,32.08c-0.16-0.03-0.31-0.05-0.46-0.05c-1.04,0-1.97,0.72-2.21,1.77h4.42 C106.64,32.97,105.98,32.28,105.09,32.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.91,32.74c-0.15-1.14-1.13-1.97-2.24-1.97c-0.11,0-0.21,0-0.31,0.02c-1.24,0.16-2.11,1.31-1.95,2.56 c0.02,0.16,0.06,0.31,0.11,0.46h4.27C65.91,33.47,65.96,33.11,65.91,32.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.54,32.61c-0.17,0-0.34,0.02-0.52,0.06c-0.66,0.15-1.18,0.59-1.48,1.14h4 C55.14,33.07,54.37,32.61,53.54,32.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.18,31.98c-0.06-1.21-1.07-2.17-2.27-2.17c-0.04,0-0.07,0.01-0.11,0.01c-1.25,0.06-2.22,1.13-2.15,2.39 c0.03,0.64,0.32,1.2,0.77,1.59h2.98C75.9,33.36,76.21,32.71,76.18,31.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.73,
    y: 33.81,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 159 72.8066)",
    className: "st1",
    width: 155.55,
    height: 5.19
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 159,
    height: 39
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasherArmBottomLowPressureCold);
export default __webpack_public_path__ + "static/media/washer_arm_bottom_low_pressure_cold.93ff12a69e893ede3a9225499779c44b.svg";
export { ForwardRef as ReactComponent };